export const setDashboardSelectedUavos = zones => ({
  type: 'SET_DASHBOARD_SELECTED_UAVOS',
  payload: zones,
});
